import React from 'react';
import { withStyles, withTheme } from '@material-ui/core';
import { compose } from 'recompose';
import Tooltip from '../../../../../../../../common/StyledToolTip';
import styles from './../styles';
import PastPickupIcon from './PastPickupIcon';

const PastPickup = ({ classes, eventHub, theme }) => {
  const onEditPickupEvent = () => {
    eventHub.emit('openPastPickup');
  };
  return (
    <div
      className={`${classes.pickupHeaderMenuIconStyles} ${classes.iconLayout} glHeaderIcons ${classes.enabledIcon}`}
      onClick={onEditPickupEvent}>
      <Tooltip title="Past Pickups">
        <PastPickupIcon color={theme.iconColor} />
      </Tooltip>
      <span className={classes.iconLabel}>Past Pickups</span>
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(PastPickup);
